<script>
import socket from '../../services/socket';
import { mapGetters } from 'vuex';
import { getToken } from '@speechki-frontend/core/auth/utils';

const SOCKET_URL = process.env.VUE_APP_WS_URL;

export default {
    name: 'SocketProvider',
    provide() {
        return {
            registerWsHandler: this.subscribeReceiver,
            removeWsHandler: this.unsubscribeReceiver
        };
    },
    props: {
        application: {
            type: String,
            default: 'api'
        }
    },
    data() {
        return {
            socket: undefined,
            heartbeatInterval: null
        };
    },
    computed: {
        ...mapGetters(['isGuestAccess']),
        token() {
            if (this.isGuestAccess) return this.$store.state.guestAccess.guestToken || getToken();
            return this.$store.state.auth.token;
        }
    },
    watch: {
        token: {
            immediate: true,
            handler(token) {
                if (!token) return;
                if (!this.socket) {
                    this.initSocket();
                    return this.connect();
                }

                this.refresh();
            }
        }
    },
    mounted() {
        window.onbeforeunload = () => this.destroy();
    },
    beforeUnmount() {
        this.destroy();
    },
    methods: {
        initSocket() {
            if (!this.token) return;

            const connection = {
                url: SOCKET_URL,
                params: {
                    application: this.application,
                    token: getToken()
                }
            };
            const opts = {
                debug: true,
                auth: cb => cb(!!this.token)
            };

            this.socket = socket(connection, opts);

            this.socket
                .on('connect', () => {
                    this.heartbeatInterval = setInterval(() => {
                        this.socket.send('hey');
                    }, 30000);
                })
                .on('disconnect', () => {
                    this.clearInteval();
                });
        },
        connect() {
            this.socket && this.socket.connect();
        },
        disconnect() {
            this.socket && this.socket.disconnect();
        },
        refresh() {
            this.socket && this.socket.refresh();
        },
        subscribeReceiver(event, callback) {
            this.socket && this.socket.receiver.on(event, callback);
        },
        unsubscribeReceiver(event, callback) {
            this.socket && this.socket.receiver.off(event, callback);
        },
        destroy() {
            this.disconnect();
            this.clearInteval();
        },
        clearInteval() {
            clearInterval(this.heartbeatInterval);
            this.heartbeatInterval = 0;
        }
    },
    render() {
        return this.$slots.default && this.$slots.default();
    }
};
</script>
